import { useState, useEffect } from 'react';

const MOBILE_BREAK_POINT = 500; // TBD 768

function useMobileView() {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth } = window;
      setIsMobileView(innerWidth < MOBILE_BREAK_POINT);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobileView;
}

export default useMobileView;
